// Imports => Constants
import { KEYS } from '@opp/ui-kit';

// Imports => Utilities
import {
  AcIsSet,
  AcIsString,
  AcIsEmptyString,
  AcGetState,
  AcSaveState,
} from '@opp/ui-kit';

export const AcGetAccessToken = () => {
  return AcGetState(KEYS.ACCESS_TOKEN);
};

export const AcSetAccessToken = (data) => {
  return AcSaveState(KEYS.ACCESS_TOKEN, data);
};

export const AcGetTokenType = () => {
  return AcGetState(KEYS.TOKEN_TYPE) || 'Bearer';
};

export const AcGetXUSRToken = () => {
  return AcGetState(KEYS.XUSR_TOKEN);
};

export const AcSetXUSRToken = (data) => {
  return AcSaveState(KEYS.XUSR_TOKEN, data);
};

export const AcRequestTransformer = (data, headers, json = true) => {
  const xuser_token = AcGetXUSRToken();
  const access_token = AcGetAccessToken();
  const token_type = AcGetTokenType() || 'Bearer';

  if (AcIsSet(access_token)) {
    headers['authorization'] = `${token_type} ${access_token}`;
  }

  if (AcIsSet(xuser_token)) {
    headers['X-OPP-Merchant-UID'] = `${xuser_token}`;
  }

  const result = json && !AcIsString(data) ? JSON.stringify(data) : data;

  return result;
};
